export const EXPENSE_CATEGORY_OPTIONS = [
    { value: "Moradia", emoji: "🏠" },
    { value: "Supermercado", emoji: "🛒" },
    { value: "Alimentação", emoji: "🍔" },
    { value: "Transporte", emoji: "🚗" },
    { value: "Combustível", emoji: "⛽" },
    { value: "Saúde", emoji: "💊" },
    { value: "Farmácia", emoji: "🩺" },
    { value: "Educação", emoji: "📚" },
    { value: "Lazer", emoji: "🎉" },
    { value: "Extra", emoji: "⚠️" },
    { value: "Assinaturas", emoji: "📺" },
    { value: "Internet e celular", emoji: "📱" },
    { value: "Contas da casa", emoji: "💡" },
    { value: "Pets", emoji: "🐶" },
    { value: "Compras", emoji: "🛍️" },
    { value: "Cartão de Crédito", emoji: "💳" },
    { value: "Viagem", emoji: "✈️" },
    { value: "\seguros", emoji: "🛡️" },
    { value: "Impostos e taxas", emoji: "🧾" },
    { value: "Outras despesas", emoji: "✨" },
];

export const REVENUE_CATEGORY_OPTIONS = [
    { value: "Salário", emoji: "💼" },
    { value: "Freelance", emoji: "💻" },
    { value: "Bônus", emoji: "🏆" },
    { value: "Dividendos", emoji: "💸" },
    { value: "Juros", emoji: "🏦" },
    { value: "Aluguel recebido", emoji: "🏘️" },
    { value: "Venda de ativo", emoji: "📈" },
    { value: "Reembolso", emoji: "🔁" },
    { value: "Presente", emoji: "🎁" },
    { value: "Outras receitas", emoji: "✨" },
];

const ALL_CATEGORY_OPTIONS = [...EXPENSE_CATEGORY_OPTIONS, ...REVENUE_CATEGORY_OPTIONS];

export const normalizeRevenueExpenseCategory = (category) =>
    (category ?? "").trim().toLowerCase();

export const getRevenueExpenseCategoryOptions = (operationType) => {
    if (operationType === "receita") {
        return REVENUE_CATEGORY_OPTIONS;
    }

    if (operationType === "despesa") {
        return EXPENSE_CATEGORY_OPTIONS;
    }

    return ALL_CATEGORY_OPTIONS;
};

export const getRevenueExpenseCategoryOption = (category) => {
    if (!category) {
        return null;
    }

    return ALL_CATEGORY_OPTIONS.find((option) => normalizeRevenueExpenseCategory(option.value) === normalizeRevenueExpenseCategory(category)) ?? null;
};

export const formatRevenueExpenseCategory = (category) => {
    const option = getRevenueExpenseCategoryOption(category);

    return option ? `${option.emoji} ${option.value}` : category;
};
